module.exports = __webpack_public_path__ + "static/media/signature_pad.57fbf376.jpeg";